import styled, { Box, useTheme } from '@xstyled/styled-components';
import { FlexBox, FlexColCenter } from '../Primitives/FlexBox';
import { ErrorMessage } from '../utils';

const Rate = styled(FlexBox)`
  padding: 1rem 0 2.5rem;
  text-align: center;

  span {
    font-weight: 700;

    &:nth-of-type(1) {
      display: inline-block;
      width: 1.8rem;
      height: 1.8rem;
      padding: 0.1rem;
      border: 1.3px solid black;
      border-radius: 50%;
      font-weight: 700;

      &:hover {
        background-color: teal-100;
        cursor: pointer;
      }
    }
  }

  input[type='radio'] {
    display: none;
  }
`;

export default function RatingScale({ rating, setRating, error }) {
  const theme = useTheme();
  return (
    <>
      <Rate spaceX={{ _: '1.6rem', sm_tablet: '3rem', desktop: '4.2rem' }}>
        {[...Array(5)].map((_, i) => {
          const ratingValue = i + 1;
          return (
            <label key={i}>
              <input
                type="radio"
                name="rating"
                value={ratingValue}
                onClick={() => setRating(ratingValue)}
              />
              <FlexColCenter spaceY="0.5rem" position="relative">
                <Box
                  as="span"
                  bg={ratingValue <= rating && theme.colors['teal-100']}
                >
                  {ratingValue}
                </Box>
                <Box
                  as="span"
                  position="absolute"
                  top="1.5rem"
                  whiteSpace={{ _: 'wrap', mobile: 'nowrap' }}
                >
                  {i === 0 ? 'Pole rahul' : i === 4 ? 'Väga rahul' : null}
                </Box>
              </FlexColCenter>
            </label>
          );
        })}
      </Rate>
      {error && <ErrorMessage whiteSpace="nowrap">{error}</ErrorMessage>}
    </>
  );
}
